var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PidManager',{staticClass:"pid-manager"}),_c('br'),_c('br'),_c('hr'),_c('br'),_c('br'),_c('PrtManager'),_c('br'),_c('br'),_c('hr'),_c('br'),_c('br'),_c('DataManagerAlternateSeat')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }